import {pxToEm} from "utils/styles/style_helpers";


export default theme =>({

    datepicker:{
        width: 'fit-content',
        '& .DayPicker':{
            position: 'relative'
        },
        '& .DayPicker-Day--selected': {
            backgroundColor: `${theme.color.primary.medium.swatch} !important`,
            '&.DayPicker-Day--outside':{
                backgroundColor: `${theme.color.light.light.swatch} !important`,
                color: `${theme.color.light.light.swatch} !important`
            },

        },
        '& .DayPicker-wrapper':{
            outline: 'none'
        },
        '& .DayPicker-Months':{
            width: '100%',
            flexWrap: 'nowrap',
            justifyContent: 'space-around',
            '& .DayPicker-Month':{
                fontSize: pxToEm(16),
                display: 'block',
                borderRadius: pxToEm(3),
                margin: ` 0 ${pxToEm(12)} ${pxToEm(12)} ${pxToEm(12)}`
            },
        },
        '& .DayPicker-Day':{
            borderRadius: 0,
            border: `${pxToEm(1)} solid ${theme.color.neutral.light.swatch}`,
            fontSize: pxToEm(13),
            '&.DayPicker-Day--disabled':{
                background: `${theme.color.neutral.xlight.swatch} !important`,
                color: theme.color.neutral.medium.swatch,
                '&.DayPicker-Day--outside':{
                    background: `${theme.color.light.light.swatch} !important`
                }
            },
            '&.DayPicker-Day--outside':{
                color: `${theme.color.light.light.swatch} !important`
            }
        },
        '& .DayPicker-Caption':{
            textAlign: 'center',
            padding: pxToEm(16),
            marginBottom: 0,
            borderLeft: `${pxToEm(1)} solid ${theme.color.neutral.light.swatch}`,
            borderRight: `${pxToEm(1)} solid ${theme.color.neutral.light.swatch}`,
            borderTop: `${pxToEm(1)} solid ${theme.color.neutral.light.swatch}`
        },
        '& .DayPicker-WeekdaysRow':{
            borderLeft: `${pxToEm(1)} solid ${theme.color.neutral.light.swatch}`,
            borderRight: `${pxToEm(1)} solid ${theme.color.neutral.light.swatch}`,
            '& .DayPicker-Weekday':{
                color: theme.color.supporting.medium.swatch,
                fontSize: pxToEm(14),
                paddingBottom: pxToEm(12)
            }
        },
        '& .icon':{
            fontSize: pxToEm(22)
        },
        '& .previousMonth':{
            color: theme.color.primary.medium.swatch,
            position: 'absolute',
            left: pxToEm(22),
            top: pxToEm(14),
            height: pxToEm(22),
            width: pxToEm(22),
            cursor: 'pointer'
        },
        '& .nextMonth':{
            color: theme.color.primary.medium.swatch,
            position: 'absolute',
            right: pxToEm(22),
            top: pxToEm(14),
            height: pxToEm(22),
            width: pxToEm(22),
            cursor: 'pointer'
        },
        '& .DayPicker-Day--today':{
            color: theme.color.supporting.light.contrast
        }
    }
})